/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BrandMapColorTheme = {
    LIGHT: 'LIGHT',
    DARK: 'DARK'
} as const;
export type BrandMapColorTheme = typeof BrandMapColorTheme[keyof typeof BrandMapColorTheme];


export function instanceOfBrandMapColorTheme(value: any): boolean {
    for (const key in BrandMapColorTheme) {
        if (Object.prototype.hasOwnProperty.call(BrandMapColorTheme, key)) {
            if (BrandMapColorTheme[key as keyof typeof BrandMapColorTheme] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BrandMapColorThemeFromJSON(json: any): BrandMapColorTheme {
    return BrandMapColorThemeFromJSONTyped(json, false);
}

export function BrandMapColorThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandMapColorTheme {
    return json as BrandMapColorTheme;
}

export function BrandMapColorThemeToJSON(value?: BrandMapColorTheme | null): any {
    return value as any;
}

export function BrandMapColorThemeToJSONTyped(value: any, ignoreDiscriminator: boolean): BrandMapColorTheme {
    return value as BrandMapColorTheme;
}

